import { siteRoutes } from "../siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { NewsOverview, SingleNews } from "@/features/news";
import { PageDoesntExist } from "@/pageDoesntExist";
import AuthRoleWrapper from "../AuthRoleWrapper";
import NewsManage from "@/pages/News/NewsManage.ui";

export const newsRoutes = [
  // * News
  {
    element: !brand.hasFeature.news ? PageDoesntExist : NewsOverview,
    path: siteRoutes["news"], // route to news overview
  },
  {
    element: !brand.hasFeature.news ? PageDoesntExist : SingleNews,
    path: `${siteRoutes["newsAndSlug"]}:slug`, // route to news overview
  },
  // * Creating and managing news
  {
    element: brand.hasCreate.news
      ? () => AuthRoleWrapper({ Component: NewsManage })
      : PageDoesntExist,
    path: siteRoutes["createNews"], // route to news overview
  },
  {
    element: brand.hasCreate.news
      ? () => AuthRoleWrapper({ Component: NewsManage })
      : PageDoesntExist,
    path: `${siteRoutes["manageNews"]}:slug`, // route to news overview
  },
];
